"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

exports.useInput = function (Component, initial) {
  var _a = react_1.useState(initial),
      value = _a[0],
      setValue = _a[1];

  var element = react_1.default.createElement(Component, {
    value: value,
    onChange: setValue
  });
  return {
    value: value,
    setValue: setValue,
    Input: function Input(props) {
      return react_1.cloneElement(element, __assign({}, element.props, props));
    }
  };
};